import Vue from 'vue'
export const EventBus = new Vue({
  data: {
    activeAudio: {
      jimmy: false,
      reyhan: false,
      tom: false,
      ivo: false,
      maayke: false,
      helene: false
    }
  }
})



// WEBPACK FOOTER //
// ./src/EventBus.js